(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-description-toggle')) {
    customElements.define(
      'product-description-toggle',
      class ProductDescriptionToggle extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('[data-description-content]');
          this.button = this.querySelector('[data-description-button]');
          if (!this.content || !this.button) return;

          this.labelMore = this.button.querySelector('[data-label-more]');
          this.labelLess = this.button.querySelector('[data-label-less]');
          this.expanded = false;

          this.onClick = () => this.setExpanded(!this.expanded);
          // A link focused in the clamped part would be invisible: reveal the full text instead.
          this.onFocusIn = () => {
            if (this.hasAttribute('data-collapsed')) this.setExpanded(true);
          };
          this.button.addEventListener('click', this.onClick);
          this.content.addEventListener('focusin', this.onFocusIn);

          // Only a width change (resize, hidden parent such as a modal becoming visible) can change the line count.
          // Ignoring height changes also keeps the toggle itself from retriggering the measure.
          this.width = 0;
          this.resizeObserver = new ResizeObserver((entries) => {
            const { width } = entries[0].contentRect;
            if (width === this.width) return;
            this.width = width;
            this.update();
          });
          this.resizeObserver.observe(this.content);

          // Web fonts can change the line count without any width change.
          if (document.fonts) document.fonts.ready.then(() => this.isConnected && this.update());

          this.width = this.content.getBoundingClientRect().width;
          this.update();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.button) this.button.removeEventListener('click', this.onClick);
          if (this.content) this.content.removeEventListener('focusin', this.onFocusIn);
        }

        /**
         * Tells whether the text is really truncated by the CSS line clamp, which CSS alone cannot know.
         * The clamp is applied for the measure, then the real state is restored in render(). Both happen
         * in the same task, so the browser never paints the intermediate state.
         */
        update() {
          // Hidden parent: nothing measurable yet, wait for the observer.
          if (!this.content.clientWidth) return;

          this.toggleAttribute('data-collapsed', true);
          this.isOverflowing = this.content.scrollHeight > this.content.clientHeight + 1;
          // Text now fits: nothing to toggle, go back to the initial state.
          if (!this.isOverflowing) this.expanded = false;
          this.render();
        }

        setExpanded(expanded) {
          this.expanded = expanded;
          this.render();
        }

        render() {
          this.button.hidden = !this.isOverflowing;
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.toggleAttribute('data-collapsed', this.isOverflowing && !this.expanded);
          this.labelMore.hidden = this.expanded;
          this.labelLess.hidden = !this.expanded;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rivo-account-link"] && !Shopify.designMode) return;
  try {
    function initializeAccountOpenRivo() {
    const shopifyAccount = document.querySelectorAll('shopify-account');
    
    if (shopifyAccount) {
      shopifyAccount.forEach(element => {
        const wrapper = document.createElement('a');
        wrapper.setAttribute('href', '#rivo');
        element.style.pointerEvents = 'none';
        element.parentNode.insertBefore(wrapper, element);
        wrapper.appendChild(element);
        console.log(wrapper);
      });
      
    }
  }
  
  initializeAccountOpenRivo();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rivo-wishlist-heart"] && !Shopify.designMode) return;
  try {
    function initializeFavoriteButtons() {
    if (window.RivoProfileAlpine) {
      const rivoAccountWidget = document.getElementById('rivo-account-slideout');
      try {
        window.RivoProfileAlpine.$data(rivoAccountWidget)?.initializeFavoriteButtons();
      } catch (e) {
        console.warn('Rivo re-init failed:', e);
      }
    }
  }
  
  if (window.RivoJS) {
    initializeFavoriteButtons();
  } else {
    document.addEventListener('rivo-js-loaded', initializeFavoriteButtons);
  }
  } catch(e) { console.error(e); }
})();

})();
